export class AccessDeniedError extends Error {}

type OctopusMessage =
  string | { Message?: string; ErrorCode?: number; Field?: string };

export class OctopusResponseError extends Error {
  constructor(
    readonly code: number,
    readonly errorCodes: number[],
    readonly messages: string[],
    readonly fields: string[],
  ) {
    super(messages.join('\n'));
  }

  // Octopus sends Msg as plain strings or as structured errors; a throttled request gets one string, not a list.
  static fromResponse(response: {
    Code: number;
    Msg?: OctopusMessage[] | OctopusMessage;
  }): OctopusResponseError {
    const messages = ([] as OctopusMessage[]).concat(response.Msg ?? []);
    const errors = messages.map((message) =>
      typeof message === 'string' ? { Message: message } : message,
    );
    return new OctopusResponseError(
      response.Code,
      errors
        .map((error) => error.ErrorCode)
        .filter((errorCode): errorCode is number => errorCode != null),
      errors.map((error) => error.Message ?? ''),
      errors
        .map((error) => error.Field)
        .filter((field): field is string => !!field),
    );
  }
}
